import OncolensLogoWithText from '@/assets/OncolensLogoWithText.svg';
import React from 'react';
import isInternetExplorer from '@/utils/isInternetExplorer';
import clsx from 'clsx';
import environment from '@/config/environment';

interface LoginProps {
	orgReferenceCode: string;
	primaryColor?: string;
	bannerLogoPath: string;
	bannerLogoAlt: string;
	allowSignUp?: boolean;
	showPoweredBy?: boolean;
}

function LoginForm({
  orgReferenceCode: orgTagReference,
  primaryColor = '#FD8151',
  bannerLogoPath,
  bannerLogoAlt,
  allowSignUp = true,
  showPoweredBy = true
}: LoginProps) {
  let isForbiddenBrowser = false;
  if (isInternetExplorer()) {
    isForbiddenBrowser = true;
  }
  return (
    <div className="sm:mx-auto sm:w-full sm:max-w-md">
      <div className="px-4 py-8 bg-white shadow sm:rounded-lg sm:px-10">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <img className="w-auto h-20 mx-auto" src={bannerLogoPath} alt={bannerLogoAlt} />
          <h2 className="mt-6 text-2xl font-extrabold text-center text-gray-900">
						Welcome to <br/> OncoLens <span className="italic">Collaborate</span>
          </h2>
        </div>
        {isForbiddenBrowser && <ForbiddenBrowserWarning />}
        <button
          style={{background: primaryColor}}
          className={clsx(
            'relative flex items-center flex-wrap justify-center w-1/2 mx-auto p-4 border-2 border-gray-300 border-solid rounded-md hover:border-gray-400 mt-8 text-white'
          )}
          data-cy="login-button"
          onClick={() => window.location.href = GetAuth0Url(bannerLogoPath, primaryColor, orgTagReference)}>Login</button>

        {allowSignUp && (
          <div className="flex items-center justify-center mt-2">
            <p className="font-medium">If you don't have an account, <button
              className="text-blue-500"
              data-cy="signup-button"
              onClick={() => window.location.href = GetAuth0Url(bannerLogoPath, primaryColor, orgTagReference, true)}>sign up</button>
            </p>
          </div>
        )}

        {showPoweredBy && (
          <div className="flex items-center justify-center mt-10">
            <p className="font-medium">Powered by</p>
            <img className="h-12 pl-4" src={OncolensLogoWithText} alt="Oncolens Logo" />
          </div>
        )}
      </div>
      <div className="text-center">
        For assistance, please email{' '}
        <a className="text-blue-500" href="mailto:support@oncolens.com">
          support@oncolens.com
        </a>
        .
      </div>
    </div>
  );
}

const GetAuth0Url = (bannerLogoPath: string, primaryColor: string, orgTagReference: string, isSignup = false) => {
  const url = new URL(window.location.href);
  const redirectUrl = encodeURI(url.searchParams.get('redirectUrl') ?? '');
  const currentUrl = encodeURI(window.location.href.split('?')[0]);
  const authRedirectUrl = `${environment.Oncolens.authServer()}auth/callback/collaborate?org=${orgTagReference}&referredUrl=${currentUrl}&redirectUrl=${redirectUrl}`;
  return `${environment.Auth0.domain()}/authorize?client_id=${environment.Auth0.clientId()}&scope=openid+profile+email&redirect_uri=${encodeURIComponent(authRedirectUrl)}&ext-logo=${formatBannerUrl(bannerLogoPath)}&ext-brand-color=${primaryColor.replace(/#/g, '')}&response_type=code&response_mode=query${isSignup ? '&screen_hint=signup' : ''}`
}

const formatBannerUrl = (bannerUrl: string) => {
  return bannerUrl.startsWith('https') ? bannerUrl : `https://${window.location.hostname}${bannerUrl}`;
}

const ForbiddenBrowserWarning = () => (
  <div className="p-3 m-5 text-center text-red-800 bg-red-100 rounded-md">
    <p>
			This application requires a more modern browser. Please use the latest versions of Chrome,
			Safari, Edge or Firefox.
    </p>
  </div>
);

export default LoginForm;
